import React from 'react';
import { Drawer } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useFeatureEntitlements } from '@frontegg/react';
import { ProIcon } from 'src/icons/Pro.icon';
import { LockIcon } from 'src/icons/Lock.icon';
import { UpgradeTooltip } from '../Payments/UpgradeTooltip';
import { ICD10Coding } from './ICD10Coding';
import CPTCodes from './CPTCodes';

const EncounterTranscriptSheet = ({
  isVisible,
  onClose,
  activeTab,
  setActiveTab,
  encounterStatus,
}) => {
  const { isEntitled: hasICD10Access } = useFeatureEntitlements('icd-10');
  const { isEntitled: hasCPTAccess } = useFeatureEntitlements('cpt');

  const bottomSheetTabs = [
    // { label: 'Transcript', value: 'transcript' },
    ...(hasICD10Access
      ? [
          {
            label: (
              <div className="flex items-center">
                <span className="mr-1">ICD-10</span>
                <ProIcon />
              </div>
            ),
            value: 'icd10',
          },
        ]
      : [
          {
            label: (
              <UpgradeTooltip>
                <div className="flex items-center">
                  <span className="mr-1">ICD-10</span>
                  <LockIcon />
                </div>
              </UpgradeTooltip>
            ),
            value: 'icd10',
          },
        ]),
    ...(hasCPTAccess
      ? [
          {
            label: (
              <div className="flex items-center">
                <span className="mr-1">CPT</span>
                <ProIcon />
              </div>
            ),
            value: 'cpt',
          },
        ]
      : []),
  ];

  const renderBottomSheetContent = () => {
    switch (activeTab) {
      // case 'transcript':
      //   return (
      //     <div className="p-4">
      //       <h3 className="text-lg font-semibold mb-4">Live Transcript</h3>
      //       <MobileLiveTranscription
      //         encounterPhase={encounterPhase}
      //         encounterStatus={encounterStatus}
      //         fullTranscript={fullTranscript}
      //         livePartialTranscript={livePartialTranscript}
      //         selectedRecord={encounterDetails}
      //         placeholder="Transcripts will appear in real-time here."
      //       />
      //     </div>
      //   );
      case 'icd10':
        return (
          <div className="h-full">
            <ICD10Coding
              encounterStatus={encounterStatus}
              allowed={hasICD10Access}
            />
          </div>
        );
      case 'cpt':
        return (
          <div className="h-full">
            <CPTCodes
              encounterStatus={encounterStatus}
              allowed={hasCPTAccess}
            />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <Drawer
      placement="bottom"
      open={isVisible}
      closable={false}
      title={
        <div className="flex justify-between items-center pl-2 py-2">
          <div className="flex overflow-x-auto">
            {bottomSheetTabs.map((tab) => (
              <button
                key={tab.value}
                onClick={() => setActiveTab(tab.value)}
                className={`px-4 py-2 text-sm font-medium whitespace-nowrap mr-2 rounded-lg transition-colors ${
                  activeTab === tab.value
                    ? 'bg-[#00D090] text-white'
                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'
                }`}
              >
                {tab.label}
              </button>
            ))}
          </div>
          <button
            onClick={onClose}
            className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <CloseOutlined />
          </button>
        </div>
      }
      onClose={onClose}
      height="70vh"
      styles={{
        body: { padding: 0 },
      }}
    >
      <div className="flex flex-col h-full">
        <div className="flex-1 overflow-y-auto">
          {renderBottomSheetContent()}
        </div>
      </div>
    </Drawer>
  );
};

export default React.memo(EncounterTranscriptSheet);
